import React, {Component} from 'react'
import {Link} from 'react-router-dom';
import {Icon} from 'semantic-ui-react';
import {MessagesContext} from '../../../contexts/messages'

export class MessagesMenuIcon extends Component {
    static contextType = MessagesContext

    renderDot = () => {
        const {fetching, hasUnread} = this.context

        if (fetching) return <Icon loading name="sync alternate" corner="top right" color="grey"/>

        if (hasUnread) return <Icon name="circle" corner="top right" className={"unreadMessageIcon"}/>

        return null
    }

    render() {
        if (!this.context) return null

        return (<>
            <Link to="/messages">
                <Icon.Group>
                    <Icon name="mail outline" size="large" />
                    {this.renderDot()}
                </Icon.Group>
            </Link>
        </>

        )
    }
}
